import React from 'react';
import PropTypes from 'prop-types';
import BottomSheet from '../BottomSheet';
import { getTransactionDisplayName } from '../../utils/transactionPresentation';

const ConfirmDeleteModal = ({
  item,
  onDelete,
  onClose,
}) => {
  const [deleting, setDeleting] = React.useState(false);

  const handleDelete = async () => {
    if (deleting) return;

    setDeleting(true);

    try {
      await onDelete(
        item.id,
        item.tipo
      );

      onClose();
    } finally {
      setDeleting(false);
    }
  };

  return (
    <BottomSheet
      title="Excluir movimentação"
      onClose={onClose}
      size="sm"
      footer={(
        <>
          <button
            type="button"
            className="nf-sheet__danger"
            onClick={handleDelete}
            disabled={deleting}
          >
            {deleting
              ? 'Excluindo...'
              : 'Excluir'}
          </button>

          <button
            type="button"
            className="nf-sheet__secondary"
            onClick={onClose}
            disabled={deleting}
          >
            Cancelar
          </button>
        </>
      )}
    >
      <p className="nf-confirmation-copy">
        Tem certeza de que deseja excluir{' '}
        <strong>{getTransactionDisplayName(item)}</strong>?
        Essa ação não pode ser desfeita.
      </p>
    </BottomSheet>
  );
};

ConfirmDeleteModal.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    nome: PropTypes.string.isRequired,
    tipo: PropTypes.string.isRequired,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConfirmDeleteModal;
